/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ShippedDevicesStatisticDto { 
    deviceClassWithOwnIdPool?: ShippedDevicesStatisticDto.DeviceClassWithOwnIdPoolEnum;
    shippedThisMonth?: number;
    /**
     * yyyy-MM
     */
    yearMonth?: string;
}
export namespace ShippedDevicesStatisticDto {
    export const DeviceClassWithOwnIdPoolEnum = {
        Collar: 'COLLAR',
        ExternalSensor: 'EXTERNAL_SENSOR',
        Camera: 'CAMERA',
        Tt4Sensor: 'TT4_SENSOR',
        ConfigurationDevice: 'CONFIGURATION_DEVICE',
        DropOff: 'DROP_OFF',
        TrapTransmitter: 'TRAP_TRANSMITTER',
        DataLogger: 'DATA_LOGGER'
    } as const;
    export type DeviceClassWithOwnIdPoolEnum = typeof DeviceClassWithOwnIdPoolEnum[keyof typeof DeviceClassWithOwnIdPoolEnum];
}


